import { Component, Input, OnInit } from '@angular/core';
import { RmsModule } from '../../custom-modules/rms-module/rms.module';
import { OutboundDataService } from '../../services/outbound-data.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-delivery-order-report',
  templateUrl: './delivery-order.component.html',
  styleUrls: ['./delivery-order.component.scss'],
  imports: [RmsModule]
})
export class DeliveryOrderReportComponent implements OnInit {
  // Same self-fetching pattern as PurchaseOrderConfirmComponent — the
  // caller only passes an OrderID, this component loads its own data.
  @Input() data: any;

  Header: any = null;
  LineItems: any[] = [];

  constructor(private outboundData: OutboundDataService) { }

  reportReady: Promise<void> | null = null;
  ngOnInit() {
    this.reportReady = this.loadReport();
  }
  private async loadReport() {
    const result = await lastValueFrom(this.outboundData.getDocumentData(this.data.OrderID));
    if (!result?.Header || !result?.LineItems?.length) throw new Error('The order has no printable document data.');
    this.Header = result.Header;
    this.LineItems = result?.LineItems ?? [];
  }
}
